<template>
  <div
    v-if="productHasBadges"
    class="product-badge"
    :class="[
      $blockClass(blockClass, 'badge'),
      badgeColor,
    ]"
  >
    <div
      class="product-badge__text rte"
      v-text="badgeText"
    />
  </div>
</template>

<script>

/**
 * Vue: Product badge (product-badge)
 * -----------------------------------------------------------------------------
 * Production badge component.
 *
 * @param {String} [blockClass] - Block level class to apply to all elements.
 *
 */

export default {
  name: 'ProductBadge',

  props: {
    blockClass: {
      type: String,
      default: "",
    },
    product: {
      type: [Boolean, Object],
      default: false,
      required: true,
    },
  },

  computed: {

    /**
     * Check if product tags contain badge
     * @returns {Boolean}
     */
    productHasBadges() {
      if (!this.product) {
        return
      }

      let hasBadge = false
      this.product.tags.find(tag => {
        if (tag.includes('badge')) {
          hasBadge = true
        }
      })

      return hasBadge
    },

    /**
     * Compute badge text from product tag
     * @returns {String}
     */
    badgeText() {
      let badgeText = ''
      this.product.tags.find(tag => {
        if (tag.includes('badge')) {
          const tagArray = tag.split(':')
          badgeText = tagArray[tagArray.length - 1]
        }
      })

      return badgeText
    },

    /**
     * Compute badge color from product tag
     * @returns {String}
     */
    badgeColor() {
      let badgeColor = ''

      this.product.tags.find(tag => {
        if (tag.includes('badge-')) {
          const tagArray = tag.replace('badge-','').split(':')
          badgeColor = `product-badge--${tagArray[0]}`
        }
      })

      return badgeColor
    },

  },
}
</script>

<style lang="scss">
@import './product-badge';
</style>

